import React from "react";

const DualFieldIcon = ({
  type1,
  placeholder1,
  label1,
  value1,
  onChange1,
  type2,
  placeholder2,
  value2,
  onChange2,
}) => {
  return (
    <div className="mb-4">
      <label className="block text-sm text-gray-700">{label1}</label>
      <div className="flex space-x-4">
        <input
          type={type1}
          placeholder={placeholder1}
          value={value1}
          onChange={onChange1}
          className="w-1/2 py-2 pl-3 text-sm text-gray-900 border rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
        <input
          type={type2}
          placeholder={placeholder2}
          value={value2}
          onChange={onChange2}
          className="w-1/2 py-2 pl-3 text-sm text-gray-900 border rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>
    </div>
  );
};

export default DualFieldIcon;
